
document.addEventListener("DOMContentLoaded", function () {
  function makeAccordion(parentHandle, initiallyOpen = false) {
    const parentLink = document.querySelector(`#HeaderDrawer-${parentHandle}`);

    if (parentLink) {
      const parentLi = parentLink.closest('li');
      const childLis = [];
      let next = parentLi.nextElementSibling;

      while (next && next.matches('li.accordion-item')) {
        childLis.push(next);
        next = next.nextElementSibling;
      }

      const wrapper = document.createElement('div');
      wrapper.classList.add(`${parentHandle}-submenu`);
      wrapper.style.display = initiallyOpen ? 'block' : 'none';

      childLis.forEach(li => {
        wrapper.appendChild(li);
      });

      parentLi.parentNode.insertBefore(wrapper, parentLi.nextSibling);


const textNodes = Array.from(parentLink.childNodes).filter(
  node => node.nodeType === Node.TEXT_NODE && node.textContent.trim()
);

textNodes.forEach(node => {
  const span = document.createElement('span');
  span.classList.add('accordion-label');
  node.parentNode.replaceChild(span, node);
  span.appendChild(node);
});


      // Add accordion symbol to parent link
      if (!parentLink.querySelector('.accordion-symbol')) {
        const symbolSpan = document.createElement('span');
        symbolSpan.classList.add('accordion-symbol');
        parentLink.appendChild(symbolSpan);
      }

      // Set initial open/closed state
      parentLi.classList.toggle('open', initiallyOpen);
      parentLink.setAttribute('aria-expanded', String(initiallyOpen));

      parentLink.addEventListener('click', function (e) {
        e.preventDefault();

        const isOpen = wrapper.style.display === 'block';

        wrapper.style.display = isOpen ? 'none' : 'block';
        parentLi.classList.toggle('open', !isOpen);
        parentLink.setAttribute('aria-expanded', String(!isOpen));
      });
    }
  }

  // Make Designers collapsed by default
  makeAccordion('designers', false);

  // Make Shop open by default
  makeAccordion('shop', true);
});



document.querySelectorAll('.accordion-trigger').forEach((trigger) => {
  const parent = trigger.parentElement;
  
  // Start in open state
  parent.classList.add('open');

  // Ensure the span is there for CSS to target
  if (!trigger.querySelector('.accordion-symbol')) {
    const symbolSpan = document.createElement('span');
    symbolSpan.classList.add('accordion-symbol');
    trigger.appendChild(symbolSpan);
  }

  trigger.addEventListener('click', (e) => {
    e.preventDefault(); // prevent anchor jump if needed
    parent.classList.toggle('open');
  });
});


















document.addEventListener("DOMContentLoaded", function() {
  const accordions = document.querySelectorAll(".collapsible-content details");

  accordions.forEach(accordion => {
    accordion.addEventListener("click", function() {
      // Close all other accordions
      accordions.forEach(otherAccordion => {
        if (otherAccordion !== accordion) {
          otherAccordion.removeAttribute("open");
        }
      });
    });
  });
}); 





class ProductTabs{constructor(){this.init()}init(){const t=document.querySelector(".product__info-wrapper");if(!t)return;const e=t.querySelector("product-info");if(!e)return;const c=Array.from(t.querySelectorAll(".product__accordion")),n=t.querySelector(".productlist-grid");0!==c.length&&this.createTabs(e,c,n)}createTabs(t,e,c){const n=document.createElement("div");n.className="product-tabs";const a=document.createElement("ul");a.className="product-tabs__nav";const o=document.createElement("div");o.className="product-tabs__content";[...e.map(((t,e)=>{const c=t.querySelector("details"),n=c?.querySelector("summary"),a=c?.querySelector(".accordion__content"),o=n?.textContent.trim()||`Tab ${e+1}`,r=document.createElement("div");return r.className="tab-content",a&&(r.innerHTML=a.innerHTML),{title:o,content:r,id:`tab-${e}`}})),...c?[{title:"Styled With",content:c,id:"tab-styled-with"}]:[]].forEach(((t,e)=>{const c=document.createElement("li");c.innerHTML=`\n                <button class="product-tabs__nav-button ${0===e?"active":""}" \n                    data-tab="${t.id}">\n                    ${t.title}\n                </button>\n            `,a.appendChild(c);const n=document.createElement("div");n.id=t.id,n.className="product-tabs__panel "+(0===e?"active":""),n.appendChild(t.content.cloneNode(!0)),o.appendChild(n)})),a.addEventListener("click",(t=>{const e=t.target.closest(".product-tabs__nav-button");e&&(a.querySelectorAll(".product-tabs__nav-button").forEach((t=>t.classList.remove("active"))),o.querySelectorAll(".product-tabs__panel").forEach((t=>t.classList.remove("active"))),e.classList.add("active"),document.getElementById(e.dataset.tab)?.classList.add("active"))})),n.appendChild(a),n.appendChild(o),t.appendChild(n),e.forEach((t=>t.remove())),c?.remove()}}document.addEventListener("DOMContentLoaded",(()=>{new ProductTabs}));


/*
document.addEventListener("DOMContentLoaded", () => {
    const productTexts = document.querySelectorAll("p.product__text.inline-richtext");
    const tabContents = document.querySelectorAll(".tab-content");

    if (productTexts.length > 0 && tabContents.length > 0) {
        tabContents.forEach((tabContent) => {
            // Append each productText block to the end of each tab-content
            productTexts.forEach((productText) => {
                tabContent.appendChild(productText.cloneNode(true));
            });
        });

        // Remove original productText elements after cloning them
        productTexts.forEach((productText) => productText.remove());
    }
});
*/


document.addEventListener("DOMContentLoaded", () => {
  const productTexts = document.querySelectorAll("p.product__text.inline-richtext");
  const tabContents = document.querySelectorAll(".tab-content");

  if (productTexts.length > 0 && tabContents.length > 0) {
    tabContents.forEach((tabContent) => {
      // create a wrapper for all appended text
      const textGroup = document.createElement("div");
      textGroup.classList.add("product-text-group");

      // clone each paragraph into the wrapper
      productTexts.forEach((productText) => {
        textGroup.appendChild(productText.cloneNode(true));
      });

      // append wrapper to the bottom of the tab content
      tabContent.appendChild(textGroup);
    });

    // remove original text paragraphs from DOM
    productTexts.forEach((productText) => productText.remove());
  }
});














document.addEventListener('DOMContentLoaded', function () {
  const colorSwatches = document.querySelectorAll('.color-swatch');

  colorSwatches.forEach((swatch) => {
    const colorName = swatch.getAttribute('data-color');
    const swatchImage = swatch.getAttribute('data-swatch-image');
    const isColorValid = (color) => {
      const style = new Option().style;
      style.color = color;
      return style.color !== '';
    };

    // Check if the custom swatch image exists
    const img = new Image();
    img.src = swatchImage;
    img.onload = function () {
      // Use the custom image if it exists
      swatch.style.backgroundImage = `url(${swatchImage})`;
      swatch.style.backgroundColor = 'transparent';
    };
    img.onerror = function () {
      // Fall back to HTML color if custom image doesn't exist
      if (isColorValid(colorName)) {
        swatch.style.backgroundColor = colorName;
        swatch.style.backgroundImage = 'none';
      } else {
        // Optional: Handle cases where neither image nor valid color exists
        swatch.style.backgroundColor = '#ccc'; // Default placeholder color
      }
    };
  });
});






document.addEventListener('DOMContentLoaded', function() {
  const description = document.querySelector('.collection-hero__description.rte');
  const textWrapper = document.querySelector('.collection-hero__text-wrapper');
  
  if (description && textWrapper) {
    // Check if the description element is empty
    if (description.textContent.trim() === '') {
      textWrapper.style.justifyContent = 'flex-start';
    }
  }
});




document.addEventListener('DOMContentLoaded', function() {
  // Get the current page URL path (e.g., "/collections/tops")
  const currentPath = window.location.pathname;

  // Select all mega menu links
  const megaMenuLinks = document.querySelectorAll('li > a.mega-menu__link');

  megaMenuLinks.forEach(link => {
    // Check if the link's href path matches the current path
    if (link.getAttribute('href') === currentPath) {
      link.style.textDecoration = 'underline'; // Apply underline to the active link
    }
  });
});





/*
document.addEventListener('DOMContentLoaded', function() {
  const variantSelects = document.querySelectorAll('[name="id"]');

  if (variantSelects) {
    variantSelects.forEach(select => {
      select.addEventListener('change', function() {
        const selectedVariant = this.value;
        if (selectedVariant) {
          const newUrl = new URL(window.location.href);
          newUrl.searchParams.set('variant', selectedVariant);
          window.location.href = newUrl.toString(); // Refresh page with updated variant
        }
      });
    });
  }
});
*/




document.addEventListener('DOMContentLoaded', function () {
    // Check periodically if the email input field exists and is focused
    const removeFocusInterval = setInterval(function () {
        const emailInput = document.querySelector('#email_01JCQ8FQS3FFGE8R9M5KY8HJD5');

        if (emailInput && document.activeElement === emailInput) {
            // Remove focus from the email input field
            emailInput.blur();

            // Stop checking once focus is removed
            clearInterval(removeFocusInterval);
        }
    }, 100); // Check every 100ms
});





document.addEventListener("DOMContentLoaded", function () {
  function checkContainerHeight() {
    const variantPicker = document.querySelector(".variant-picker:first-of-type");
    const productFormInput = document.querySelector(".product-form__input");

    if (variantPicker && productFormInput) {
      // Convert rem to pixels (assuming 1rem = 16px; adjust if different)
      const remInPixels = 16; // Adjust if your rem size differs
      const threeRem = 3 * remInPixels; // 3rem in pixels
      const fourRem = 4 * remInPixels;  // 4rem in pixels
      const fiveRem = 5 * remInPixels;  // 5rem in pixels
      const sixRem = 6 * remInPixels;   // 6rem in pixels
      const sevenRem = 7 * remInPixels; // 7rem in pixels
      const eightRem = 8 * remInPixels; // 8rem in pixels
      const nineRem = 9 * remInPixels;  // 9rem in pixels

      // Get the current height of the product-form__input
      const inputHeight = productFormInput.offsetHeight;

      console.log(`Input Height: ${inputHeight}px`); // Debugging output

      // Check the height of the .product-form__input
      if (inputHeight > nineRem) {
        console.log("Height exceeds 9rem. Adding 15rem margin."); // Debugging output
        variantPicker.style.marginBottom = "15rem";
      } else if (inputHeight > eightRem) {
        console.log("Height exceeds 8rem but less than or equal to 9rem. Adding 13rem margin."); // Debugging output
        variantPicker.style.marginBottom = "13rem";
      } else if (inputHeight > sevenRem) {
        console.log("Height exceeds 7rem but less than or equal to 8rem. Adding 11rem margin."); // Debugging output
        variantPicker.style.marginBottom = "11rem";
      } else if (inputHeight > sixRem) {
        console.log("Height exceeds 6rem but less than or equal to 7rem. Adding 9rem margin."); // Debugging output
        variantPicker.style.marginBottom = "9rem";
      } else if (inputHeight > fiveRem) {
        console.log("Height exceeds 5rem but less than or equal to 6rem. Adding 7rem margin."); // Debugging output
        variantPicker.style.marginBottom = "7rem";
      } else if (inputHeight > fourRem) {
        console.log("Height exceeds 4rem but less than or equal to 5rem. Adding 5rem margin."); // Debugging output
        variantPicker.style.marginBottom = "5rem";
      } else if (inputHeight > threeRem) {
        console.log("Height exceeds 3rem but less than or equal to 4rem. Adding 3rem margin."); // Debugging output
        variantPicker.style.marginBottom = "3rem";
      } else {
        console.log("Height is less than or equal to 3rem. Resetting margin."); // Debugging output
        variantPicker.style.marginBottom = "";
      }
    }
  }

  // Run on page load
  checkContainerHeight();

  // Optionally, rerun on window resize
  window.addEventListener("resize", checkContainerHeight);
});









